/**
 * @generated SignedSource<<ee83f2d5ce372f670f1019deaf3f52a3>>
 * @relayHash 2aa21dfe81db93c3891fcd6de4336484
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0ac480d0f50f269bd87cc5d34758f758414afec44e114b0613ba8da64dc4c68a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CustomerDetailsCustomerDetailsPageQuery } from './CustomerDetailsCustomerDetailsPageQuery.graphql';

import isAssetsFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerContextRelayprovider';

const node: PreloadableConcreteRequest<CustomerDetailsCustomerDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0ac480d0f50f269bd87cc5d34758f758414afec44e114b0613ba8da64dc4c68a",
    "metadata": {},
    "name": "CustomerDetailsCustomerDetailsPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerContextRelayprovidertsx": isAssetsFieldEnabled_provider
    }
  }
};

export default node;
